module.exports = __webpack_public_path__ + "static/media/opinion_modern.de1bc013.png";